import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, UtensilsCrossed } from "lucide-react";
import { useSite } from "@/context/SiteContext";
import { useLang } from "@/context/LanguageContext";

export default function Footer() {
  const { settings } = useSite();
  const { t } = useLang();
  const s = settings || {};
  return (
    <footer className="bg-[#1A1A1A] text-[#F9F6F0]" data-testid="main-footer">
      <div className="max-w-7xl mx-auto px-5 py-16 grid gap-12 md:grid-cols-4">
        <div className="md:col-span-2">
          <div className="flex items-center gap-2.5 mb-5">
            {s.logo_url ? (
              <img src={s.logo_url} alt={s.business_name || "Mayuresh Caterers"} className="h-12 w-auto object-contain" />
            ) : (
              <>
                <span className="w-9 h-9 flex items-center justify-center bg-[#C9A66B]">
                  <UtensilsCrossed size={18} className="text-[#1A1A1A]" />
                </span>
                <span className="serif text-2xl font-semibold">Mayuresh Caterers</span>
              </>
            )}
          </div>
          <p className="text-white/60 max-w-md leading-relaxed">
            {s.tagline || "Premium catering crafted for your celebrations"} — serving Roha, Raigad
            and surrounding Konkan with authentic, elegant menus for every occasion.
          </p>
        </div>

        <div>
          <h4 className="label-tag text-[#C9A66B] mb-5">{t("explore")}</h4>
          <ul className="space-y-3 text-white/70 text-sm">
            <li><Link to="/services" className="hover:text-[#C9A66B]">Services</Link></li>
            <li><Link to="/gallery" className="hover:text-[#C9A66B]">Gallery</Link></li>
            <li><Link to="/build" className="hover:text-[#C9A66B]">Build Your Menu</Link></li>
            <li><Link to="/about" className="hover:text-[#C9A66B]">About & Contact</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="label-tag text-[#C9A66B] mb-5">{t("reachUs")}</h4>
          <ul className="space-y-4 text-white/70 text-sm">
            <li className="flex gap-3"><MapPin size={18} className="text-[#C9A66B] shrink-0" /> {s.address || "Roha, Raigad 402116"}</li>
            <li className="flex gap-3"><Phone size={18} className="text-[#C9A66B] shrink-0" /> {s.phone || "+91 98765 43210"}</li>
            <li className="flex gap-3"><Mail size={18} className="text-[#C9A66B] shrink-0" /> {s.email || "hello@mayuresh.in"}</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-5 py-5 flex flex-col sm:flex-row justify-between gap-2 text-white/40 text-xs">
          <span>© {new Date().getFullYear()} Mayuresh Caterers, Roha, Raigad 402116. {t("rights")}</span>
          <span>{t("poweredBy")} <a href="https://omaxtech.com" target="_blank" rel="noopener noreferrer" className="text-[#C9A66B] hover:text-[#E4CE9E]">Omaxtech</a></span>
        </div>
      </div>
    </footer>
  );
}
